<template>
  <div class="prescriptionDetails">
    <el-page-header @back="goBack" content="不良上报详情"></el-page-header>
    <div class="prescriptionDetails_content">
        <div class="clearfix-sapn">会员资料</div>
        <div class="card">
          <span>姓名：{{listData.patientName}}</span>
          <span>性别：{{listData.gender}}</span>
          <span>年龄：{{listData.patientAge}}</span>
          <span>就诊时间：{{listData.createTime}}</span>
        </div>

        
        <div class="clearfix-sapn">患者资料</div>
        <div class="card">
          <span>姓名：{{listData.patientName}}</span>
          <span>性别：{{listData.patientGender}}</span>
          <span>年龄：{{listData.patientAge}}</span>
          <span>订单编号：{{listData.orderNumber}}</span>
        </div>

        <div class="clearfix-sapn">上报资料</div>
        <div class="card">
          <span>发生时间：{{listData.eventTime}}</span>
          <span>日期类型：{{listData.dateType}}</span>
          <span>上报时间：{{listData.reportTime}}</span>
          <span>医疗类别：{{listData.medicalType}}</span>
          <span>事件级别：{{listData.eventTypeName}}</span>
          <span>不良事件的类别：{{listData.eventLevelName}}</span>
          <span>患者情况：{{listData.memberSituation}}</span>
          <span>事件基本情况：{{listData.comment}}</span>
        </div>
        
        <div class="clearfix-sapn">医生资料</div>
        <div class="card">
          <span>医生姓名：{{listData.doctorName}}</span>
          <span>医生科室：{{listData.departmentName}}</span>
          <span>医生职称：{{listData.professionalName}}</span>
          <span>报告时间：{{listData.createTime}}</span>
        </div>
    </div>
  </div>
</template>

<script>
// import { addAdverseShowCheck } from "@/api";
import { getEventForm } from "@/api/doctor";
import util from "@/utils";
import emptyData from "@/components/common/emptyData.vue";
import prescriptionPdf from "@/components/prescriptionPdf";
import caseDetail from "@/components/case/detail";

export default {
  name: "adverseReactionDetail",
  components: { emptyData, prescriptionPdf, caseDetail },
  props: {},
  data() {
    return {
      listData: [],
      listDataType: {},
      detailInfo: "",
      id: this.$route.query.id,
      // case_id: this.$route.query.case_id,
    };
  },
  created() {
    this.getEventForm()
    // this.readyList();
  },
  methods: {
    goBack() {
      const that = this;
      // that.$router.go(-1); //返回上一层
      that.$router.push({
        path: "/index/user/adverseReaction",
      });
    },
    /**
     * 初次获取数据
     */
    // 新
    async getEventForm() {
      const params = {
        id: this.$route.query.id,
      };
      const res = await getEventForm(params)
      if(res.code == 1){
        this.listData = res.data
      }
    },
    // 旧
    async readyList() {
      try {
        const params = {
          id: this.$route.query.id,
        };
        let res = await addAdverseShowCheck(params);
        if (res.success) {
          this.listData = res.result;
          console.log(this.listData);
          // this.listDataType = res.result;
          // this.detailInfo = res.result;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.prescriptionDetails {
  width: 100%;
  padding: 20px;
  .prescriptionDetails_content{
    width: 100%;
    padding: 20px;
    
    .clearfix-sapn {
      border-left: 5px solid #fc701a;
      padding-left: 5px;
      margin-bottom: 10px;
      // color: #8e99ca;
    }
    .card{
      padding: 10px;
      
      span{
        display: inline-block;
        width: 33.333%;
        line-height: 1.5;
        margin-bottom: 15px;
      }
    }
  }
  .status_card {
    // float: right;
    z-index: 100;
    display: block;
    text-align: center;
    vertical-align: middle;
    position: fixed;
  }
}
</style>
